import { useMemo } from 'react'
import { OrderStepButtonsBase, OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import { SellDownloadButtonPDF, SellDownloadPdfTemplateButton, SellPdfPreview, SellQuickAccessButton } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellLayout/SellButtons'
import useTwinTranslation from '../../../../../../../../../../../utils/hooks/useTwinTranslation'
import { OrderStepButtonsDefaultBaseComponent, OrderStepButtonsNewStyleBaseComponent } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent'

const SellDeliveryNoteRefundFinishedStepButtons: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    return (
        <OrderStepButtonsDefaultBaseComponent {...{ data, onSubmit, hookFunction: useDeliveryNoteRefundFinishedStepButtonsLogic, ...rest }} className='mr-8' />
    )
}

const useDeliveryNoteRefundFinishedStepButtonsLogic = ({ data }: OrderStepButtonsBaseComponentProps) => {
    const { t } = useTwinTranslation()
    const name = 'sell_delivery_note_refund_finished_step_buttons'
    const Order = data?.header
    const hideSellQuickAccesButton = !Order?.QuoteOrderId && !Order?.SellOrderId && !Order?.SellDeliveryNoteId && !Order?.SellInvoiceId && !Order?.WorkSheetId && !Order?.relatedSellOrders?.length && !Order?.relatedSellDeliveryNotes?.length && !Order?.relatedSellInvoices?.length && !Order?.relatedWorkSheets?.length

    const defaultButtons = [{ "id": "previewSellInvoiceRefund" }, { "id": "downloadSellInvoiceRefund" }, { "id": "quickAccess" }]

    const sellOrderQuickAccessText = t('quickAccess', 'Acceso rápido')
    const sellOrderPreviewPDFText = t('previewPdf', 'Previsualizar PDF')
    const sellOrderDownloadPDFTemplateText = t('downloadPdfTemplate', 'Descargar plantilla PDF')
    const sellOrderDownloadPDFText = t('downloadPdf', 'Descargar PDF')

    const ButtonComponents: OrderStepButtonsBase = useMemo(() => {
        return {
            quickAccess: {
                component: SellQuickAccessButton,
                showButton: !hideSellQuickAccesButton,
                extraProps: {
                    title: sellOrderQuickAccessText,
                    id: 'quickAccess',
                    Order,
                }
            },
            previewSellInvoiceRefund: {
                component: SellPdfPreview,
                extraProps: {
                    title: sellOrderPreviewPDFText,
                    id: 'previewSellInvoiceRefund',
                    Order,
                    typeTemplate: 'sellRefundInvoice',
                }
            },
            downLoadSellOrderTemplate: {
                component: SellDownloadPdfTemplateButton,
                extraProps: {
                    title: sellOrderDownloadPDFTemplateText,
                    id: 'downLoadSellOrderTemplate',
                    Order,
                    typeTemplate: 'sellRefundInvoice',
                }
            },
            downloadSellInvoiceRefund: {
                component: SellDownloadButtonPDF,
                extraProps: {
                    title: sellOrderDownloadPDFText,
                    id: 'downloadSellInvoiceRefund',
                    Order,
                    typeTemplate: 'sellRefundInvoice',
                    key: 'sellRefundInvoice'
                }
            },
        }
    }, [Order, hideSellQuickAccesButton, sellOrderDownloadPDFTemplateText, sellOrderDownloadPDFText, sellOrderPreviewPDFText, sellOrderQuickAccessText])

    return { name, ButtonComponents, defaultButtons }
}

export const SellDeliveryNoteRefundFinishedStepButtonsNew: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    return (
        <OrderStepButtonsNewStyleBaseComponent {...{ data, onSubmit, hookFunction: useDeliveryNoteRefundFinishedStepButtonsLogic, ...rest }} className='mr-8' />
    )
}

export default SellDeliveryNoteRefundFinishedStepButtons